import { MAX_PHOTO_BYTES, MAX_SONG_BYTES, PHOTO_EXTENSIONS, SONG_EXTENSIONS } from "./constants";

export const MEDIA_KINDS = ["photo", "song"] as const;
export type MediaKind = (typeof MEDIA_KINDS)[number];

const CONTENT_TYPES: Readonly<Record<string, string>> = {
  wav: "audio/wav",
  flac: "audio/flac",
  mp3: "audio/mpeg",
  m4a: "audio/mp4",
  aac: "audio/aac",
  png: "image/png",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
};

/** Extensions (without the dot) accepted for a media kind. */
export function extensionsFor(kind: MediaKind): readonly string[] {
  return kind === "song" ? SONG_EXTENSIONS : PHOTO_EXTENSIONS;
}

export function isExtensionAllowed(kind: MediaKind, ext: string): boolean {
  return extensionsFor(kind).includes(ext);
}

/** Largest accepted upload for a kind: 20 MiB for songs, 5 MiB for photos. */
export function maxBytesFor(kind: MediaKind): number {
  return kind === "song" ? MAX_SONG_BYTES : MAX_PHOTO_BYTES;
}

export function contentTypeFor(ext: string): string {
  return CONTENT_TYPES[ext] ?? "application/octet-stream";
}
